import React from 'react';

export function SectionDivider({
  motif = false,
  className = '',
  ...props
}) {
  return motif ? (
    <div className={`flex justify-center my-12 ${className}`} {...props}>
      <svg width="120" height="16" viewBox="0 0 120 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="60" cy="8" rx="60" ry="8" fill="url(#gold)" fillOpacity="0.15" />
        <defs>
          <linearGradient id="gold" x1="0" y1="8" x2="120" y2="8" gradientUnits="userSpaceOnUse">
            <stop stopColor="#d4af37" />
            <stop offset="1" stopColor="#fffbe6" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  ) : (
    <hr className={`border-t-2 border-accent/40 my-12 ${className}`} {...props} />
  );
}

export default SectionDivider;
